/**
 * Import dependencies.
 */
import {h, Component} from 'preact';
import classnames from 'classnames/dedupe';

/**
 * Import local dependencies.
 */

/**
 * Import styles.
 */
import '@material/toolbar/mdc-toolbar.scss';

/**
 * Create the component.
 */
export default class ToolbarTitle extends Component {
  render({
           'class': className,
           children,
           ...props
         }, state, context) {
    const classes = classnames('mdc-toolbar__title', className);
    return (
      <span class={classes} {...props}>{children}</span>
    );
  }
}



// WEBPACK FOOTER //
// ../q-mdc/elements/material-toolbar-title/index.js